// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WifiBox_wrapper__2HvFz","contentWrapper":"WifiBox_contentWrapper__346K8"};